import React from 'react'
import PropTypes from 'prop-types'

const ProspectsToWatch = props => (
  <div className="ProspectsToWatch">
    <ul>
      {props.data.map(prospect => (
        <li key={`${prospect.name}${prospect.logo}${prospect.sharePerCent}`}>
          <div
            className="ProspectsToWatch_thumbnail"
            style={{ backgroundImage: `url(${prospect.logo})` }}
          />
          <div className="ProspectsToWatch_info">
            <span className="ProspectsToWatch_title">{prospect.name}</span>
            <span className="ProspectsToWatch_percentage">
              {Math.round(prospect.sharePerCent)}%
            </span>

            <div className="ProspectsToWatch_chart">
              <div
                className="ProspectsToWatch_chart_bar"
                style={{
                  width: `${prospect.sharePerCent}%`,
                }}
              />
            </div>
          </div>
        </li>
      ))}
    </ul>
  </div>
);

ProspectsToWatch.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default ProspectsToWatch;;
